import React from "react";

class GenericErrorBoundary extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = { showErrors: false, hasError: false, error: null, info: null };
    }

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ hasError: true, error, info });
    }

    setShowErrors(showErrors) {
        this.setState({ showErrors });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <></>;
        }
        return this.props.children;
    }
}

export default GenericErrorBoundary;
